module.exports = __webpack_public_path__ + "zvetseni-prsou_66_before.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/zvetseni-prsou_66_before.jpg
// module id = 1360
// module chunks = 0